<template>
    <div class="main">
        <c-panel title="AVALIAÇÕES EXTERNAS" titleIcon="fas fa-award">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Catálogo dos instrumentos de avaliação externa da rede (SAEB, Prova Brasil, ANA, avaliações municipais)."
                description="Os resultados por escola e ano são lançados na aba Avaliações Externas do cadastro de cada instituição."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou sigla..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.esfera" clearable placeholder="Esfera" style="width: 100%;" @change="carregar">
                        <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/avaliacao-externa/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA AVALIAÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Avaliação</th>
                            <th style="width: 110px;">Sigla</th>
                            <th style="width: 140px;">Esfera</th>
                            <th style="width: 140px;" class="hidden-mobile">Periodicidade</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="a in items" :key="a.id">
                            <td>{{ a.nome }}</td>
                            <td>{{ a.sigla || '—' }}</td>
                            <td>{{ rotulo(a.esfera) }}</td>
                            <td class="hidden-mobile">{{ a.periodicidade ? rotulo(a.periodicidade) : '—' }}</td>
                            <td class="u-text-center">{{ a.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/avaliacao-externa/edit/' + a.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(a.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhuma avaliação cadastrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — itens 30, 31 e 70. Interface para `api/ext-avaliacao`. */
export default {
    data: () => ({
        statusList: false, filtro: { nome: '', esfera: '' }, items: [],
        esferas: ['federal', 'estadual', 'municipal']
    }),
    computed: {
        /** Esconder o botão não é segurança — o backend continua sendo a autoridade. */
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ext-avaliacao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (v) {
            return { federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal',
                anual: 'Anual', bienal: 'Bienal', eventual: 'Eventual' }[v] || v
        },
        excluir (id) {
            this.$confirm('Excluir esta avaliação externa?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/ext-avaliacao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Avaliação excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
